import { getType, getActionCreator } from 'shared/lib';
const prefix = '@@app/salaryEmployees';

export const FETCH_EMPLOYEES_REQUEST = getType(
  prefix,
  'FETCH_EMPLOYEES_REQUEST'
);
export const fetchEmployeesRequest = getActionCreator(FETCH_EMPLOYEES_REQUEST);

export const FETCH_EMPLOYEES_DEBOUNCED_REQUEST = getType(
  prefix,
  'FETCH_EMPLOYEES_DEBOUNCED_REQUEST'
);
export const fetchEmployeesDebouncedRequest = getActionCreator(
  FETCH_EMPLOYEES_DEBOUNCED_REQUEST
);

export const FETCH_EMPLOYEES_SUCCESS = getType(
  prefix,
  'FETCH_EMPLOYEES_SUCCESS'
);
export const fetchEmployeesSuccess = getActionCreator(FETCH_EMPLOYEES_SUCCESS);

export const FETCH_LAST_SYNC_TIME_SUCCESS = getType(
  prefix,
  'FETCH_LAST_SYNC_TIME_SUCCESS'
);
export const fetchLastSyncTimeSuccess = getActionCreator(
  FETCH_LAST_SYNC_TIME_SUCCESS
);

export const FETCH_IS_SYNCING_SUCCESS = getType(
  prefix,
  'FETCH_IS_SYNCING_SUCCESS'
);
export const fetchIsSyncingSuccess = getActionCreator(FETCH_IS_SYNCING_SUCCESS);

export const FETCH_EMPLOYEES_ERROR = getType(prefix, 'FETCH_EMPLOYEES_ERROR');
export const fetchEmployeesError = getActionCreator(FETCH_EMPLOYEES_ERROR);

export const CHANGE_EMPLOYEES_FILTERS = getType(
  prefix,
  'CHANGE_EMPLOYEES_FILTERS'
);
export const changeEmployeesFilters = getActionCreator(
  CHANGE_EMPLOYEES_FILTERS
);

export const SET_EMPLOYEES_FILTERS = getType(prefix, 'SET_EMPLOYEES_FILTERS');
export const setEmployeesFilters = getActionCreator(SET_EMPLOYEES_FILTERS);

export const SET_EMPLOYEES_SEARCH = getType(prefix, 'SET_EMPLOYEES_SEARCH');
export const setEmployeesSearch = getActionCreator(SET_EMPLOYEES_SEARCH);

export const SET_DATE_RANGE = getType(prefix, 'SET_DATE_RANGE');
export const setDateRange = getActionCreator(SET_DATE_RANGE);

export const RESET_EMPLOYEES_FILTERS = getType(
  prefix,
  'RESET_EMPLOYEES_FILTERS'
);
export const resetEmployeesFilters = getActionCreator(RESET_EMPLOYEES_FILTERS);

/* ========== SCHEDULES =========== */

export const SET_SCHEDULE_ID = getType(prefix, 'SET_SCHEDULE_ID');
export const setScheduleId = getActionCreator(SET_SCHEDULE_ID);

export const SET_EMPLOYEE_SCHEDULE = getType(prefix, 'SET_EMPLOYEE_SCHEDULE');
export const setEmployeeSchedule = getActionCreator(SET_EMPLOYEE_SCHEDULE);

export const SET_EMPLOYEE_SCHEDULE_SUCCESS = getType(
  prefix,
  'SET_EMPLOYEE_SCHEDULE_SUCCESS'
);
export const setEmployeeScheduleSuccess = getActionCreator(
  SET_EMPLOYEE_SCHEDULE_SUCCESS
);

export const FETCH_COMPANY_BRANCHES_REQUEST = getType(
  prefix,
  'FETCH_COMPANY_BRANCHES_REQUEST'
);
export const fetchCompanyBranchesRequest = getActionCreator(
  FETCH_COMPANY_BRANCHES_REQUEST
);

export const FETCH_COMPANY_BRANCHES_SUCCESS = getType(
  prefix,
  'FETCH_COMPANY_BRANCHES_SUCCESS'
);
export const fetchCompanyBranchesSuccess = getActionCreator(
  FETCH_COMPANY_BRANCHES_SUCCESS
);

export const DOWNLOAD_EMPLOYEES_TABLE_XLSX = getType(
  prefix,
  'DOWNLOAD_EMPLOYEES_TABLE_XLSX'
);
export const downloadEmployeesTableXlsx = getActionCreator(
  DOWNLOAD_EMPLOYEES_TABLE_XLSX
);

export const DOWNLOAD_EMPLOYEE_PAYSLIPS = getType(
  prefix,
  'DOWNLOAD_EMPLOYEE_PAYSLIPS'
);
export const downloadEmployeePayslips = getActionCreator(
  DOWNLOAD_EMPLOYEE_PAYSLIPS
);

export const DOWNLOAD_EMPLOYEE_PAYSLIPS_SUCCESS = getType(
  prefix,
  'DOWNLOAD_EMPLOYEE_PAYSLIPS_SUCCESS'
);
export const downloadEmployeePayslipsSuccess = getActionCreator(
  DOWNLOAD_EMPLOYEE_PAYSLIPS_SUCCESS
);

export const DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS = getType(
  prefix,
  'DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS'
);
export const downloadCompanyEmployeesPayslips = getActionCreator(
  DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS
);

export const DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS_SUCCESS = getType(
  prefix,
  'DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS_SUCCESS'
);
export const downloadCompanyEmployeesPayslipsSuccess = getActionCreator(
  DOWNLOAD_COMPANY_EMPLOYEES_PAYSLIPS_SUCCESS
);

export const REFRESH_SILAE_EMPLOYEES = getType(
  prefix,
  'REFRESH_SILAE_EMPLOYEES'
);
export const refreshSilaeEmployees = getActionCreator(REFRESH_SILAE_EMPLOYEES);

export const INIT_EMPLOYEES = getType(prefix, 'INIT_EMPLOYEES');
export const initEmployees = getActionCreator(INIT_EMPLOYEES);

export const SET_EMPLOYEES_PAGE_PAGINATION = getType(
  prefix,
  'SET_CALENDAR_PAGE_PAGINATION'
);
export const setEmployeesPagePagination = getActionCreator(
  SET_EMPLOYEES_PAGE_PAGINATION
);

export const SET_EMPLOYEES_PAGE = getType(prefix, 'SET_CALENDAR_PAGE');
export const setEmployeesPage = getActionCreator(SET_EMPLOYEES_PAGE);

export const SET_ALL_EMPLOYEES = getType(prefix, 'SET_ALL_EMPLOYEES');
export const setAllEmployees = getActionCreator(SET_ALL_EMPLOYEES);
